/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/location';
import '../common/currency';
import '../customer_field_definition_setting/service';
import '../api/sync/sync';
import './calendar';
import './common';
import '../client/bills/cart';
import '../omg/model/orders';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "agenda": {
        "nested": {
          "AgendaType": {
            "values": {
              "SERVICE": 0,
              "APPOINTMENT": 1,
              "CLIENT": 2,
              "STAFF": 3,
              "PLACEHOLDER_EVENT": 4,
              "BUSINESS": 5,
              "BOOKED_SERVICE": 6,
              "WIDGET": 7,
              "HOURS": 8,
              "HOURS_COLLECTION": 9,
              "INSTRUMENT": 10,
              "PAYMENT": 11,
              "CONFIRMATION": 12,
              "CONFIRMATION_MESSAGE": 13,
              "REMINDER_MESSAGE": 14,
              "AVAILABILITY_OVERRIDE": 15
            }
          },
          "AppointmentStatus": {
            "values": {
              "TEMPORARY": 0,
              "PENDING": 1,
              "CANCELLED_BY_BUYER": 4,
              "CANCELLED_BY_SELLER": 5,
              "DECLINED": 2,
              "ACCEPTED": 3,
              "NO_SHOW": 6
            }
          },
          "AppointmentSource": {
            "values": {
              "UNKNOWN": 0,
              "FACEBOOK": 1,
              "INSTAGRAM": 2,
              "OBS": 3,
              "RESERVE_WITH_GOOGLE": 4,
              "YELP": 5,
              "API": 6,
              "IMPORT": 7,
              "ROBOT": 8,
              "MARKETPLACE": 9,
              "RESERVE_WITH_GOOGLE_V2": 10
            }
          },
          "EventAvailabilityType": {
            "values": {
              "FREE": 0,
              "BUSY": 1
            }
          },
          "ClientExternalSourceType": {
            "values": {
              "NOT_IMPORTED": 0,
              "IOS": 1
            }
          },
          "TimestampList": {
            "fields": {
              "timestamp": {
                "type": ".squareup.common.time.DateTime",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "MaxReservationTypeScope": {
            "nested": {
              "MaxReservationType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "NONE": 1,
                  "STAFF": 2,
                  "LOCATION": 3
                }
              }
            }
          },
          "MarketplaceOnboardingStateScope": {
            "nested": {
              "MarketplaceOnboardingState": {
                "values": {
                  "DO_NOT_USE": 0,
                  "NOT_ONBOARDED": 1,
                  "BUSINESS_INFO": 2,
                  "REVIEW": 3,
                  "COMPLETED": 4
                }
              }
            }
          },
          "QrCodeFormatScope": {
            "nested": {
              "QrCodeFormat": {
                "values": {
                  "DO_NOT_USE": 0,
                  "SIMPLE": 1,
                  "DETAILED": 2
                }
              }
            }
          },
          "Business": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "name": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "phoneNumber": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "needsMobileOnboarding": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "locationType": {
                "type": ".squareup.agenda.Business.LocationType",
                "id": 5,
                "rule": "optional"
              },
              "timeZone": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "address": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 7,
                "rule": "optional"
              },
              "noShowCutoffTime": {
                "type": "int64",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "uid": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "noShowProtectionEnabled": {
                "type": "bool",
                "id": 10,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "buyerPrepaymentMode": {
                "type": ".squareup.agenda.Business.BuyerPrepaymentMode",
                "id": 11,
                "rule": "optional",
                "options": {
                  "default": "OFF"
                }
              },
              "noShowChargeType": {
                "type": ".squareup.agenda.Business.NoShowChargeType",
                "id": 12,
                "rule": "optional"
              },
              "noShowPercentage": {
                "type": "int32",
                "id": 13,
                "rule": "optional"
              },
              "noShowFlatFee": {
                "type": ".squareup.common.Money",
                "id": 14,
                "rule": "optional"
              },
              "bankAccountVerified": {
                "type": "bool",
                "id": 15,
                "rule": "optional"
              },
              "bookingSitesEnabled": {
                "type": "bool",
                "id": 16,
                "rule": "optional"
              },
              "sendReminderSms": {
                "type": "bool",
                "id": 17,
                "rule": "optional"
              },
              "sendReminderEmail": {
                "type": "bool",
                "id": 18,
                "rule": "optional"
              },
              "reminderSmsLeadTime": {
                "type": "int32",
                "id": 19,
                "rule": "optional"
              },
              "reminderEmailLeadTime": {
                "type": "int32",
                "id": 20,
                "rule": "optional"
              },
              "reserveWithGoogleEnabled": {
                "type": "bool",
                "id": 21,
                "rule": "optional"
              },
              "eligibleForReserveWithGoogle": {
                "type": "bool",
                "id": 22,
                "rule": "optional"
              },
              "sendConfirmationSms": {
                "type": "bool",
                "id": 23,
                "rule": "optional"
              },
              "sendConfirmationEmail": {
                "type": "bool",
                "id": 24,
                "rule": "optional"
              },
              "confirmationLeadTime": {
                "type": "uint32",
                "id": 25,
                "rule": "optional"
              },
              "conversationsEnabled": {
                "type": "bool",
                "id": 26,
                "rule": "optional"
              },
              "isSoleProprietor": {
                "type": "bool",
                "id": 27,
                "rule": "optional"
              },
              "locationTypeVideoCallEnabled": {
                "type": "bool",
                "id": 28,
                "rule": "optional"
              },
              "cancellationPolicy": {
                "type": "string",
                "id": 29,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 30,
                "rule": "optional"
              },
              "minisiteDeprecated": {
                "type": "bool",
                "id": 31,
                "rule": "optional"
              },
              "depositsEnabled": {
                "type": "bool",
                "id": 32,
                "rule": "optional"
              },
              "depositChargeType": {
                "type": ".squareup.agenda.Business.DepositChargeType",
                "id": 33,
                "rule": "optional"
              },
              "depositAmountCents": {
                "type": "int32",
                "id": 34,
                "rule": "optional"
              },
              "depositAmountPercentage": {
                "type": "int32",
                "id": 35,
                "rule": "optional"
              },
              "depositCancellationFeeTaxEnabled": {
                "type": "bool",
                "id": 36,
                "rule": "optional"
              },
              "depositCancellationFeeTaxPercentage": {
                "type": "string",
                "id": 37,
                "rule": "optional"
              },
              "depositRefundPolicy": {
                "type": "string",
                "id": 38,
                "rule": "optional"
              },
              "customerFieldDefinitionSettings": {
                "type": ".squareup.customerFieldDefinitionSetting.CustomerFieldDefinitionSettingsByBookingType",
                "id": 39,
                "rule": "repeated"
              },
              "marketplaceStatus": {
                "type": ".squareup.agenda.Business.MarketplaceStatus",
                "id": 40,
                "rule": "optional"
              },
              "hasBookingForms": {
                "type": "bool",
                "id": 41,
                "rule": "optional"
              },
              "depositAmountFixedFee": {
                "type": ".squareup.common.Money",
                "id": 42,
                "rule": "optional"
              },
              "displayTextMarketingOptIn": {
                "type": "bool",
                "id": 43,
                "rule": "optional"
              },
              "displayEmailMarketingOptIn": {
                "type": "bool",
                "id": 44,
                "rule": "optional"
              },
              "buyerPrepaymentTippingEnabled": {
                "type": "bool",
                "id": 45,
                "rule": "optional"
              },
              "requireCofWhenBooking": {
                "type": "bool",
                "id": 46,
                "rule": "optional"
              },
              "marketplaceOnboardingState": {
                "type": ".squareup.agenda.MarketplaceOnboardingStateScope.MarketplaceOnboardingState",
                "id": 47,
                "rule": "optional"
              },
              "scarcity": {
                "type": "int32",
                "id": 48,
                "rule": "optional"
              },
              "displayCancellationPolicy": {
                "type": "bool",
                "id": 49,
                "rule": "optional"
              },
              "multipleStaffBookingEnabled": {
                "type": "bool",
                "id": 50,
                "rule": "optional"
              },
              "multipleServiceBookingEnabled": {
                "type": "bool",
                "id": 51,
                "rule": "optional"
              },
              "maxReservationType": {
                "type": ".squareup.agenda.MaxReservationTypeScope.MaxReservationType",
                "id": 52,
                "rule": "optional"
              },
              "maxReservationLimit": {
                "type": "int32",
                "id": 53,
                "rule": "optional"
              },
              "cutoffTime": {
                "type": "int32",
                "id": 54,
                "rule": "optional"
              },
              "restype": {
                "type": "string",
                "id": 55,
                "rule": "optional"
              },
              "alignmentTime": {
                "type": "int32",
                "id": 56,
                "rule": "optional"
              },
              "allowUserCancel": {
                "type": "bool",
                "id": 57,
                "rule": "optional"
              },
              "futureBookingLimitTime": {
                "type": "int32",
                "id": 58,
                "rule": "optional"
              },
              "anyStaffBookingEnabled": {
                "type": "bool",
                "id": 59,
                "rule": "optional"
              },
              "skipObsStaffSelection": {
                "type": "bool",
                "id": 60,
                "rule": "optional"
              },
              "customerCanSetBookingTimezone": {
                "type": "bool",
                "id": 61,
                "rule": "optional"
              },
              "onlineBookingEnabled": {
                "type": "bool",
                "id": 62,
                "rule": "optional"
              },
              "marketplaceEnabled": {
                "type": "bool",
                "id": 63,
                "rule": "optional"
              },
              "qrCodeFormat": {
                "type": ".squareup.agenda.QrCodeFormatScope.QrCodeFormat",
                "id": 64,
                "rule": "optional"
              },
              "serviceImagesEnabled": {
                "type": "bool",
                "id": 65,
                "rule": "optional"
              },
              "categoriesEnabled": {
                "type": "bool",
                "id": 66,
                "rule": "optional"
              },
              "categoryImagesEnabled": {
                "type": "bool",
                "id": 67,
                "rule": "optional"
              }
            },
            "nested": {
              "LocationType": {
                "values": {
                  "PREMISES": 0,
                  "CUSTOMER": 1,
                  "PHONE": 2,
                  "OTHER": 3
                }
              },
              "BuyerPrepaymentMode": {
                "values": {
                  "OFF": 0,
                  "ALL_CLIENTS_REQUIRED": 1
                }
              },
              "NoShowChargeType": {
                "values": {
                  "PERCENTAGE": 0,
                  "FLAT_FEE": 1,
                  "PER_SERVICE": 2,
                  "PERCENTAGE_PER_SERVICE": 3
                }
              },
              "DepositChargeType": {
                "values": {
                  "DEPOSIT_FIXED_FEE": 0,
                  "DEPOSIT_PERCENTAGE": 1
                }
              },
              "MarketplaceStatus": {
                "values": {
                  "DO_NOT_USE": 0,
                  "MIGRATED_AND_ENABLED": 1,
                  "MIGRATED_AND_DISABLED": 2,
                  "NOT_MIGRATED": 3
                }
              }
            }
          },
          "Appointment": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "clientId": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 2,
                "rule": "optional"
              },
              "staff": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 3,
                "rule": "optional"
              },
              "startDate": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              },
              "servicesEndDate": {
                "type": ".squareup.common.time.DateTime",
                "id": 5,
                "rule": "optional"
              },
              "allDay": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "timeZone": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "recurrenceRule": {
                "type": ".squareup.agenda.RecurrenceRule",
                "id": 8,
                "rule": "optional"
              },
              "excludeDates": {
                "type": ".squareup.agenda.TimestampList",
                "id": 9,
                "rule": "optional"
              },
              "parent": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 10,
                "rule": "optional"
              },
              "status": {
                "type": ".squareup.agenda.AppointmentStatus",
                "id": 11,
                "rule": "optional",
                "options": {
                  "default": "TEMPORARY"
                }
              },
              "sellerNote": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "buyerNote": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "transitionTime": {
                "type": "int64",
                "id": 14,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "creationDate": {
                "type": ".squareup.common.time.DateTime",
                "id": 15,
                "rule": "optional"
              },
              "locationType": {
                "type": ".squareup.agenda.Appointment.LocationType",
                "id": 16,
                "rule": "optional"
              },
              "address": {
                "type": ".squareup.common.location.GlobalAddress",
                "id": 17,
                "rule": "optional"
              },
              "statusUpdateDate": {
                "type": ".squareup.common.time.DateTime",
                "id": 20,
                "rule": "optional"
              },
              "clientName": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "clientMessage": {
                "type": ".squareup.agenda.ClientMessage",
                "id": 22,
                "rule": "optional"
              },
              "cart": {
                "type": ".squareup.client.bills.Cart",
                "id": 23,
                "rule": "optional"
              },
              "readOnly": {
                "type": "bool",
                "id": 24,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "merchantMessageOptions": {
                "type": ".squareup.agenda.MerchantMessageOptions",
                "id": 25,
                "rule": "optional"
              },
              "version": {
                "type": "int32",
                "id": 26,
                "rule": "optional"
              },
              "source": {
                "type": ".squareup.agenda.AppointmentSource",
                "id": 27,
                "rule": "optional",
                "options": {
                  "default": "UNKNOWN"
                }
              },
              "videoCallUrl": {
                "type": "string",
                "id": 28,
                "rule": "optional"
              },
              "videoCallBuyerUrl": {
                "type": "string",
                "id": 29,
                "rule": "optional"
              },
              "videoCallPassword": {
                "type": "string",
                "id": 30,
                "rule": "optional"
              },
              "checkoutProhibited": {
                "type": "bool",
                "id": 31,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "contractTokens": {
                "type": "string",
                "id": 32,
                "rule": "repeated"
              },
              "reservationSegments": {
                "type": ".squareup.agenda.ReservationSegment",
                "id": 33,
                "rule": "repeated"
              },
              "order": {
                "type": ".squareup.omg.model.Order",
                "id": 34,
                "rule": "optional"
              },
              "invoiceId": {
                "type": "string",
                "id": 35,
                "rule": "optional"
              },
              "isNoShowEnabled": {
                "type": "bool",
                "id": 36,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "cardId": {
                "type": "string",
                "id": 37,
                "rule": "optional"
              },
              "creatorClient": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 18
              },
              "creatorStaff": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 19
              }
            },
            "nested": {
              "LocationType": {
                "values": {
                  "PREMISES": 0,
                  "CUSTOMER": 1,
                  "PHONE": 2,
                  "VIDEO_CALL": 3
                }
              },
              "creator": {
                "oneof": ["creatorClient", "creatorStaff"]
              }
            }
          },
          "ReservationSegment": {
            "fields": {
              "lineItemUid": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "teamMemberId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "resourceId": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "serviceTimeSeconds": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "intermissionStartOffsetSeconds": {
                "type": "int32",
                "id": 5,
                "rule": "optional"
              },
              "intermissionEndOffsetSeconds": {
                "type": "int32",
                "id": 6,
                "rule": "optional"
              },
              "itemName": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "itemToken": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "itemVersion": {
                "type": "int64",
                "id": 9,
                "rule": "optional"
              },
              "itemVariationName": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "itemVariationToken": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "itemVariationVersion": {
                "type": "int64",
                "id": 12,
                "rule": "optional"
              },
              "anyAvailableTeamMember": {
                "type": "bool",
                "id": 13,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "MerchantMessageOptions": {
            "fields": {
              "suppressMerchantMessages": {
                "type": "bool",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          },
          "Staff": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "firstName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "lastName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "business": {
                "type": ".squareup.api.sync.ObjectId",
                "id": 4,
                "rule": "optional"
              },
              "userToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "smsNotificationsEnabled": {
                "type": "bool",
                "id": 6,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "emailNotificationsEnabled": {
                "type": "bool",
                "id": 7,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "iosNotificationsEnabled": {
                "type": "bool",
                "id": 8,
                "rule": "optional",
                "options": {
                  "default": true
                }
              },
              "hasPromptedToDisableSmsNotifications": {
                "type": "bool",
                "id": 9,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "personToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "colorScheme": {
                "type": ".squareup.agenda.Staff.ColorScheme",
                "id": 11,
                "rule": "optional",
                "options": {
                  "default": "BLUE"
                }
              },
              "role": {
                "type": ".squareup.agenda.Staff.Role",
                "id": 12,
                "rule": "optional",
                "options": {
                  "default": "NO_ACCESS"
                }
              },
              "phoneNumber": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "employeeToken": {
                "type": "string",
                "id": 14,
                "rule": "optional"
              },
              "zoomUserId": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              }
            },
            "nested": {
              "ColorScheme": {
                "values": {
                  "BLUE": 1,
                  "GREEN": 2,
                  "ORANGE": 3,
                  "PURPLE": 4,
                  "YELLOW": 5,
                  "TURQUOISE": 6,
                  "DARK_BLUE": 7,
                  "DARK_ORANGE": 8,
                  "DARK_PURPLE": 9,
                  "MUTED_BLUE": 10,
                  "MINT": 11,
                  "BLACK": 12
                }
              },
              "Role": {
                "values": {
                  "NO_ACCESS": 0,
                  "SELF_ACCESS": 1,
                  "ALL_STAFF_ACCESS": 2,
                  "FULL_ACCESS": 3
                }
              }
            }
          },
          "ValidateAposDataRequest": {
            "fields": {
              "appointmentsTokens": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "personalEventsTokens": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "syncFilters": {
                "type": ".squareup.api.sync.AgendaSyncFilter",
                "id": 3,
                "rule": "repeated"
              },
              "customerIds": {
                "type": "string",
                "id": 4,
                "rule": "repeated"
              },
              "syncToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "dbCreationTime": {
                "type": ".squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.agenda?.nested?.AgendaType && !$root.nested?.squareup?.nested?.agenda?.nested?.AppointmentStatus && !$root.nested?.squareup?.nested?.agenda?.nested?.AppointmentSource && !$root.nested?.squareup?.nested?.agenda?.nested?.EventAvailabilityType && !$root.nested?.squareup?.nested?.agenda?.nested?.ClientExternalSourceType && !$root.nested?.squareup?.nested?.agenda?.nested?.TimestampList && !$root.nested?.squareup?.nested?.agenda?.nested?.MaxReservationTypeScope?.nested?.MaxReservationType && !$root.nested?.squareup?.nested?.agenda?.nested?.MarketplaceOnboardingStateScope?.nested?.MarketplaceOnboardingState && !$root.nested?.squareup?.nested?.agenda?.nested?.QrCodeFormatScope?.nested?.QrCodeFormat && !$root.nested?.squareup?.nested?.agenda?.nested?.Business && !$root.nested?.squareup?.nested?.agenda?.nested?.Business?.nested?.LocationType && !$root.nested?.squareup?.nested?.agenda?.nested?.Business?.nested?.BuyerPrepaymentMode && !$root.nested?.squareup?.nested?.agenda?.nested?.Business?.nested?.NoShowChargeType && !$root.nested?.squareup?.nested?.agenda?.nested?.Business?.nested?.DepositChargeType && !$root.nested?.squareup?.nested?.agenda?.nested?.Business?.nested?.MarketplaceStatus && !$root.nested?.squareup?.nested?.agenda?.nested?.Appointment && !$root.nested?.squareup?.nested?.agenda?.nested?.Appointment?.nested?.LocationType && !$root.nested?.squareup?.nested?.agenda?.nested?.ReservationSegment && !$root.nested?.squareup?.nested?.agenda?.nested?.MerchantMessageOptions && !$root.nested?.squareup?.nested?.agenda?.nested?.Staff && !$root.nested?.squareup?.nested?.agenda?.nested?.Staff?.nested?.ColorScheme && !$root.nested?.squareup?.nested?.agenda?.nested?.Staff?.nested?.Role && !$root.nested?.squareup?.nested?.agenda?.nested?.ValidateAposDataRequest) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AgendaType @ squareup/agenda/agendasync.proto at 29:1
 */
export const AgendaType = $root.lookupEnum('squareup.agenda.AgendaType').values;
/**
 * Appointments have many potential 'states' that they transition to.
 * State transitions can occur either as a side effect of other actions, or as a direct PUT, however there are
 * restrictions.
 * In simplest terms, buyers must PUT their appointment in state TEMPORARY when first creating one, then PUT
 * that same appointment in PENDING when they are ready to commit to the appointment.  They may also DECLINE
 * an appointment that is PENDING, but not when it is ACCEPTED.
 * Sellers, on the other hand, may only PUT either ACCEPTED in response to a PENDING, or DECLINE in response to
 * either a PENDING or ACCEPTED.
 * Writing the same status you read is always safe.
 *
 * SOURCE AppointmentStatus @ squareup/agenda/agendasync.proto at 82:1
 */
export const AppointmentStatus = $root.lookupEnum('squareup.agenda.AppointmentStatus').values;
/**
 * The creation source of the appointment
 *
 * SOURCE AppointmentSource @ squareup/agenda/agendasync.proto at 132:1
 */
export const AppointmentSource = $root.lookupEnum('squareup.agenda.AppointmentSource').values;
/**
 * The availability status of a PlaceholderEvent, representing whether a slot is available or busy.
 *
 * SOURCE EventAvailabilityType @ squareup/agenda/agendasync.proto at 166:1
 */
export const EventAvailabilityType = $root.lookupEnum('squareup.agenda.EventAvailabilityType').values;
/**
 * The external source from which this client is imported.
 *
 * SOURCE ClientExternalSourceType @ squareup/agenda/agendasync.proto at 182:1
 */
export const ClientExternalSourceType = $root.lookupEnum('squareup.agenda.ClientExternalSourceType').values;
/**
 * SOURCE TimestampList @ squareup/agenda/agendasync.proto at 235:1
 */
export const TimestampList = $root.lookupType('squareup.agenda.TimestampList');
fixType(TimestampList);
Builder.createAndAttachToType(TimestampList);
/**
 * Enums wrapped in scopes so that DO_NOT_USE can be reused.
 *
 * SOURCE MaxReservationTypeScope @ squareup/agenda/agendasync.proto at 242:1
 */
export const MaxReservationTypeScope = {};
/**
 * SOURCE MaxReservationType @ squareup/agenda/agendasync.proto at 243:3
 */
MaxReservationTypeScope.MaxReservationType = $root.lookupEnum('squareup.agenda.MaxReservationTypeScope.MaxReservationType').values;
/**
 * SOURCE MarketplaceOnboardingStateScope @ squareup/agenda/agendasync.proto at 251:1
 */
export const MarketplaceOnboardingStateScope = {};
/**
 * SOURCE MarketplaceOnboardingState @ squareup/agenda/agendasync.proto at 252:3
 */
MarketplaceOnboardingStateScope.MarketplaceOnboardingState = $root.lookupEnum('squareup.agenda.MarketplaceOnboardingStateScope.MarketplaceOnboardingState').values;
/**
 * SOURCE QrCodeFormatScope @ squareup/agenda/agendasync.proto at 260:1
 */
export const QrCodeFormatScope = {};
/**
 * SOURCE QrCodeFormat @ squareup/agenda/agendasync.proto at 261:3
 */
QrCodeFormatScope.QrCodeFormat = $root.lookupEnum('squareup.agenda.QrCodeFormatScope.QrCodeFormat').values;
/**
 * Business is the root of the object graph. There should ever only be one synced to an individual client
 *
 * SOURCE Business @ squareup/agenda/agendasync.proto at 273:1
 */
export const Business = $root.lookupType('squareup.agenda.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * Indicates where a business' appointments take place
 *
 * SOURCE LocationType @ squareup/agenda/agendasync.proto at 275:3
 */
Business.LocationType = $root.lookupEnum('squareup.agenda.Business.LocationType').values;
/**
 * Type of Buyer Prepayment feature being used by the business.
 *
 * SOURCE BuyerPrepaymentMode @ squareup/agenda/agendasync.proto at 289:3
 */
Business.BuyerPrepaymentMode = $root.lookupEnum('squareup.agenda.Business.BuyerPrepaymentMode').values;
/**
 * Type of charge calculation used when a customer no-shows.
 *
 * SOURCE NoShowChargeType @ squareup/agenda/agendasync.proto at 300:3
 */
Business.NoShowChargeType = $root.lookupEnum('squareup.agenda.Business.NoShowChargeType').values;
/**
 * Type of charge calculation used when a customer no-shows.
 *
 * SOURCE DepositChargeType @ squareup/agenda/agendasync.proto at 317:3
 */
Business.DepositChargeType = $root.lookupEnum('squareup.agenda.Business.DepositChargeType').values;
/**
 * SOURCE MarketplaceStatus @ squareup/agenda/agendasync.proto at 442:3
 */
Business.MarketplaceStatus = $root.lookupEnum('squareup.agenda.Business.MarketplaceStatus').values;
/**
 * SOURCE Appointment @ squareup/agenda/agendasync.proto at 612:1
 */
export const Appointment = $root.lookupType('squareup.agenda.Appointment');
fixType(Appointment);
Builder.createAndAttachToType(Appointment);
/**
 * SOURCE LocationType @ squareup/agenda/agendasync.proto at 613:3
 */
Appointment.LocationType = $root.lookupEnum('squareup.agenda.Appointment.LocationType').values;
/**
 * SOURCE ReservationSegment @ squareup/agenda/agendasync.proto at 754:1
 */
export const ReservationSegment = $root.lookupType('squareup.agenda.ReservationSegment');
fixType(ReservationSegment);
Builder.createAndAttachToType(ReservationSegment);
/**
 * SOURCE MerchantMessageOptions @ squareup/agenda/agendasync.proto at 795:1
 */
export const MerchantMessageOptions = $root.lookupType('squareup.agenda.MerchantMessageOptions');
fixType(MerchantMessageOptions);
Builder.createAndAttachToType(MerchantMessageOptions);
/**
 * A staff member of a business. Services can only be performed by specific staff members
 *
 * SOURCE Staff @ squareup/agenda/agendasync.proto at 1005:1
 */
export const Staff = $root.lookupType('squareup.agenda.Staff');
fixType(Staff);
Builder.createAndAttachToType(Staff);
/**
 * SOURCE ColorScheme @ squareup/agenda/agendasync.proto at 1064:3
 */
Staff.ColorScheme = $root.lookupEnum('squareup.agenda.Staff.ColorScheme').values;
/**
 * DEPRECATED.
 * Permissions are now controlled by employee management, and no new code should use this.
 * The type of actions the staff can perform
 * Each role has a superset of permissions of the role before it
 * The numeric values of these enums are consistent with the values in the appointments database
 *
 * SOURCE Role @ squareup/agenda/agendasync.proto at 1088:3
 */
Staff.Role = $root.lookupEnum('squareup.agenda.Staff.Role').values;
/**
 * SOURCE ValidateAposDataRequest @ squareup/agenda/agendasync.proto at 1477:1
 */
export const ValidateAposDataRequest = $root.lookupType('squareup.agenda.ValidateAposDataRequest');
fixType(ValidateAposDataRequest);
Builder.createAndAttachToType(ValidateAposDataRequest);